<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="6" lg="4" class="ma-0 pa-0 pb-3 pl-2">
        <v-select :style="{fontWeight:700}"
          :items="getSelectedChecklists"
          @change="goToChecklistForm"
          item-text="name"
          item-value="id"
          v-model="getChecklist"
          :label="$t('message.layout.checklists')"
          dense
          hide-details
          outlined
        >
        </v-select>
      </v-col>
      <v-col cols="12" v-if="$vuetify.breakpoint.lgAndUp" sm="6" lg="4"></v-col>
    </v-row>
    <data-list :payload="modelObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="shareChecklist.dialog" persistent max-width="1150px" class="mt-0">
      <v-form ref="sendEmailForm" onSubmit="return false;">
        <v-card>
          <v-card-title>
            {{ $t('message.checklist.sendChecklist') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-col cols="12">
              <v-row>
                <v-autocomplete outlined dense name="contact" hide-details multiple v-model="shareChecklist.users" @change="getEmailForUsers"
                  :items="getUsers" item-text="fullname" item-value="id"
                  :label="$t('message.tickets.to')">
                </v-autocomplete>
              </v-row>
              <v-row class="mt-4">
                <v-text-field outlined dense v-model="shareChecklist.mails" ref="autoFocus" :rules="$_requiredValidation"
                  persistent-hint :hint="$t('message.common.add_extra_mails')"></v-text-field>
              </v-row>
              <v-row class="mt-4">
                <v-text-field outlined dense v-model="shareChecklist.subject" :rules="$_requiredValidation"
                  persistent-hint :hint="$t('message.tickets.subject')"></v-text-field>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" id="sendMail" :loading="shareChecklist.loading" @click="shareChecklist.onSuccess">{{ $t('message.common.send') }}</v-btn>
            <v-btn color="error" id="close" @click="shareChecklist.onCancel">{{ $t('message.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import DataList from '@/components/DataList'
import helpers from '@/utils/checklistutils/download'
export default {
  props: ['module', 'filterObj', 'model', 'payload', 'propId'],
  data () {
    return {
      getChecklist: 0,
      modelObj: {
        hideOpen: true,
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        hasPermission: true,
        hideSearch: true,
        addNewRoute: () => null,
        headers: [],
        list: [],
        isStock: true,
        hasFilters: false,
        relateClickHandler: () => null,
        loading: true,
        editProp: 'name',
        is_checklist: true,
        editHandler: this.updateChecklistDialog,
        hideTop: true,
        footer: true,
        fromCheckLsit: true,
        actionsList: [{
          click: (item) => this.downloadChecklist(item),
          icon: (item) => 'mdi-download',
          is_show: (item) => true,
          color: (item) => 'primary'
        }, {
          click: (item) => this.shareChecklistHandler(item),
          icon: (item) => 'mdi-email',
          is_show: (item) => true,
          color: (item) => 'info'
        }],
        refreshHandler: this.getListHandler
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.PROPS_INDEX) ? this.$store.state.PROPS_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      search: '',
      getSelectedChecklists: [],
      moduleName: 'checklists',
      shareChecklist: {
        users: [],
        dialog: false,
        loading: false,
        onSuccess: () => false,
        onCancel: () => false
      }
    }
  },
  components: {
    DataList
  },
  computed: {
    ...mapState(['userDetails']),
    ...mapGetters(['listOfModules', 'getUsers']),
    headers () {
      return [{
        text: this.$t('message.props.name'),
        value: 'name',
        sortable: true,
        dbRef: 'Name'
      }, {
        text: `${this.$t('message.unimicro.updatedBy')}`,
        value: 'updated_by_user',
        sortable: true
      }, {
        text: `${this.$t('message.order.updatedOn')}`,
        value: 'updated_on',
        sortable: true
      }, {
        text: this.$t('message.props.actions'),
        value: 'actions',
        sortable: false
      }]
    }
  },
  watch: {
    search (val) {
      this.pagination.search = val
      this.getListHandler()
    },
    pagination (val) {
      this.getListHandler()
    }
  },
  created () {
    this.getListOfChecklists()
  },
  mounted () {
    this.$store.dispatch('getUsers')
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.moduleName) {
        let payload = { ids: data.ids, url: `${this.moduleName}/delete_multiple`, module: this.moduleName }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.moduleName) {
        this.modelObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
    this.$eventBus.$on('clearChecklist', () => {
      this.getChecklist = null
      this.getListHandler()
    })
  },
  methods: {
    downloadChecklist (item) {
      // eslint-disable-next-line
      let { checklist_id, form_id, name, id } = item
      this.$eventBus.$emit('showLoading')
      helpers.downloadReportHelper(checklist_id, form_id, name, process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN, null, id, item.pdftemplatepath)
        .finally(() => {
          this.$eventBus.$emit('hideLoading')
        })
    },
    shareChecklistHandler (item) {
      // eslint-disable-next-line
      let { checklist_id, form_id, name, id } = item
      const orderObj = this.$parent.$parent.order || {}
      this.shareChecklist = {
        dialog: true,
        mails: this.userDetails && this.userDetails.id ? this.userDetails.email : '',
        loading: false,
        subject: orderObj ? `${name} ${orderObj.number} ${orderObj.salesreference}` : '',
        users: this.userDetails && this.userDetails.id ? [this.userDetails.id] : [],
        onSuccess: () => {
          let isValidEmail = true
          if (!this.shareChecklist.mails.length > 0) isValidEmail = true
          let getMailIDsString = this.shareChecklist.mails
          let listOfMailIds = getMailIDsString.split(',')
          if (listOfMailIds && listOfMailIds.length > 0) {
            for (let i = 0; i < listOfMailIds.length; i++) {
              if (listOfMailIds[i]) {
                listOfMailIds[i] = listOfMailIds[i].trim()
                this.validEmail(listOfMailIds[i]) ? isValidEmail = false : isValidEmail = true
              }
            }
          }
          if (!isValidEmail) {
            this.shareChecklist.loading = true
            helpers.downloadReportHelper(checklist_id, form_id, name, process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN, null, id, item.pdftemplatepath, true)
              .then((data) => {
                const model = {
                  filename: data,
                  to: listOfMailIds,
                  subject: this.shareChecklist.subject,
                  istemplateshare: item.pdftemplatepath && item.pdftemplatepath !== 'null'
                }
                this.$_executeApi('post', 'checklists/share', model)
                  .then(async (response) => {
                    this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.tickets.sentSuccess') })
                  })
                  .finally(() => {
                    this.shareChecklist.loading = true
                    this.shareChecklist.dialog = false
                  })
              })
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidEmail') })
          }
        },
        onCancel: () => {
          this.shareChecklist.dialog = false
        }
      }
      // this.$eventBus.$emit('showLoading')
      // helpers.downloadReportHelper(checklist_id, form_id, name, process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN, null, id, item.pdftemplatepath)
      //   .finally(() => {
      //     this.$eventBus.$emit('hideLoading')
      //   })
    },
    getListOfChecklists () {
      let query = {
        filter: `status eq 'completed'`,
        order_by: {
          field: 'name',
          asc_or_desc: 'asc'
        }
      }
      this.$_executeApi('post', `checklisttemplates/query`, query).then((response) => {
        this.getSelectedChecklists = response.data
      })
    },
    getListHandler () {
      let relatedRecordId = this.$route.params[this.propId]
      this.modelObj.loading = true
      this.modelObj.module = this.moduleName
      let fields = this.$formatter.cloneVariable(this.headers)
      fields.splice(2, 1)
      fields.splice(1, 1)
      let { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let pageVal = page || 1
      let additionalfilter = ''
      let sortByProp = sortBy[0] || ''
      if (sortByProp && sortByProp === 'modifiedname') sortByProp = 'name'
      const query = {
        order_by: {
          field: sortByProp,
          asc_or_desc: sortDesc[0] ? 'desc' : 'asc'
        },
        skip: ((pageVal - 1) * itemsPerPage),
        limit: itemsPerPage,
        include_count: true,
        filter: additionalfilter
      }
      query.expand = [{
        'model': 'User',
        'on_field': 'id',
        'on_parent_field': 'updated_by'
      }]
      query.expand.push({
        'select': ['pdftemplatepath', 'checklistheader', 'checklistfooter'],
        'model': 'Checklist',
        'on_field': 'id',
        'on_parent_field': 'checklist_template_id'
      })
      query.filter = `related_record_id eq ${relatedRecordId}`
      const url = `${this.moduleName}/query`
      this.$_executeApi('post', url, query).then(async (response) => {
        this.modelObj.list = []
        let { values, count } = response.data
        this.modelObj.headers = this.headers
        values.forEach(async (x) => {
          x.updated_on = this.$formatter.formatDate(x.updated_on, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss')
          x.created_on = this.$formatter.formatDate(x.created_on, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss')
          x.updated_by_user = `${x.user_firstname || ''} ${x.user_lastname || ''}`
          x.checklistmodule = this.module
        })
        this.modelObj.list = values
        this.total = count
      }).finally(() => {
        this.modelObj.loading = false
      })
    },
    goToChecklistForm () {
      let getForm = this.getSelectedChecklists.find(x => x.id === this.getChecklist)
      if (getForm) {
        this.$eventBus.$emit('checklistDialog', getForm)
      }
      return ''
    },
    updateChecklistDialog (item) {
      this.$eventBus.$emit('updatechecklistDialog', item)
    },
    getEmailForUsers () {
      const allUsers = this.shareChecklist.users
      if (allUsers && allUsers.length > 0) {
        let getListOfUsers = this.getUsers.filter(x => allUsers.includes(x.id)).map(x => x.email)
        if (getListOfUsers && getListOfUsers.length > 0) {
          const uniqueMails = [...new Set(getListOfUsers)]
          this.shareChecklist.mails = uniqueMails.join(',')
        }
      }
    },
    validEmail: function (email) {
      // eslint-disable-next-line no-useless-escape
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    this.$eventBus.$off('clearChecklist')
  }
}
</script>
